import React from 'react';
import { motion, useViewportScroll, useTransform } from 'framer-motion';

const HowItWorks = () => {
  const { scrollYProgress } = useViewportScroll();

  // Adjust the scroll progress range to start the animation earlier
  const translateY = useTransform(scrollYProgress, [0.4, 0.6], [50, 0]);
  const opacity = useTransform(scrollYProgress, [0.4, 0.6], [0, 1]);

  return (
    <section className="bg-gray-200 py-20">
      <div className="container mx-auto px-6 text-center">
        <motion.h2
          className="text-4xl font-bold text-gray-900"
          style={{ opacity, translateY }}
        >
          How It Works
        </motion.h2>
        <motion.p
          className="text-gray-700 mt-4"
          style={{ opacity, translateY }}
        >
          Get started in just a few simple steps.
        </motion.p>

        <motion.div
          className="mt-16 flex flex-wrap justify-center"
          style={{ opacity, translateY }}
        >
          <motion.div className="w-full md:w-1/3 px-6 mb-12">
            <div className="bg-white p-8 rounded-lg shadow-lg text-center flex flex-col h-full">
              <div className="bg-black text-white text-4xl w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4">1</div>
              <h3 className="text-2xl font-semibold text-gray-900 flex-grow">Sign Up</h3>
              <p className="text-gray-700 mt-4 flex-grow">
                Create your account and set up your company profile in minutes.
              </p>
            </div>
          </motion.div>

          <motion.div className="w-full md:w-1/3 px-6 mb-12">
            <div className="bg-white p-8 rounded-lg shadow-lg text-center flex flex-col h-full">
              <div className="bg-black text-white text-4xl w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4">2</div>
              <h3 className="text-2xl font-semibold text-gray-900 flex-grow">Add Trucks and Drivers</h3>
              <p className="text-gray-700 mt-4 flex-grow">
                Create your trucks and invite your employees to sign up.
              </p>
            </div>
          </motion.div>

          <motion.div className="w-full md:w-1/3 px-6 mb-12">
            <div className="bg-white p-8 rounded-lg shadow-lg text-center flex flex-col h-full">
              <div className="bg-black text-white text-4xl w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4">3</div>
              <h3 className="text-2xl font-semibold text-gray-900 flex-grow">Track Progress</h3>
              <p className="text-gray-700 mt-4 flex-grow">
                Plan your jobs and monitor hauling productivity in real-time.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;
